<form [formGroup]="form" (ngSubmit)="submit()" class="form">
  <div class="title">Send Us A Message</div>
  <div class="field-container">
    <div class="label">TELL US YOUR NAME *</div>
    <mat-form-field appearance="outline" class="field">
      <input matInput placeholder="Name" formControlName="fullname" [maxlength]="50"/>
      @if (hasError('fullname', 'required')) {
        <mat-error>{{ ValidationMessagesConstant.Required }}</mat-error>
      }
      @for (msg of getControl('fullname').errors?.serverError; track msg.id) {
        <mat-error>{{ msg }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="field-container">
    <div class="label">ENTER YOUR EMAIL *</div>
    <mat-form-field appearance="outline" class="field">
      <input matInput placeholder="youremail@gmail.com" formControlName="email" [maxLength]="45"/>
      @if (hasError('email', 'required')) {
        <mat-error>{{ ValidationMessagesConstant.Required }}</mat-error>
      }
      @if (hasError('email', 'email')) {
        <mat-error>This is not a valid email address</mat-error>
      }
      @for (msg of getControl('email').errors?.serverError; track msg.id) {
        <mat-error>{{ msg }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="field-container">
    <div class="label">ENTER PHONE NUMBER</div>
    <mat-form-field appearance="outline" class="field">
      <input matInput placeholder="### ### ####" formControlName="phone" type="number" min="0"/>
      @if (hasError('phone', 'required')) {
        <mat-error>{{ ValidationMessagesConstant.Required }}</mat-error>
      }
      @for (msg of getControl('phone').errors?.serverError; track msg.id) {
        <mat-error>{{ msg }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="field-container">
    <div class="label">MESSAGE *</div>
    <mat-form-field appearance="outline" class="field">
      <textarea matInput placeholder="Write us a message"
                formControlName="message"
                [maxLength]="500"
                style="max-height:300px;"></textarea>
      @if (hasError('message', 'required')) {
        <mat-error>{{ ValidationMessagesConstant.Required }}</mat-error>
      }
      @for (msg of getControl('message').errors?.serverError; track msg.id) {
        <mat-error>{{ msg }}</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="button-div">
    <button matButton="filled" color="primary" type="submit" [disabled]="isLoading()">SEND MESSAGE</button>
  </div>
</form>
